// ContactUs.jsx
import React, { useState } from "react";
import { 
  FaEnvelope, 
  FaMapMarkerAlt, 
  FaPhone, 
  FaPaperPlane,
  FaFacebook,
  FaTwitter,
  FaLinkedin,
  FaInstagram
} from "react-icons/fa";
import { Link } from "react-router-dom";
import "./ContactUs.css";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  const [errors, setErrors] = useState({});

  const validateForm = () => {
    let tempErrors = {};
    
    if (!formData.name.trim()) {
      tempErrors.name = "Name is required";
    } else if (formData.name.length < 2) {
      tempErrors.name = "Name must be at least 2 characters";
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!formData.email) {
      tempErrors.email = "Email is required";
    } else if (!emailRegex.test(formData.email)) {
      tempErrors.email = "Please enter a valid email address";
    }

    const phoneRegex = /^[0-9]{10}$/;
    if (!formData.phone) {
      tempErrors.phone = "Phone number is required";
    } else if (!phoneRegex.test(formData.phone)) {
      tempErrors.phone = "Please enter a valid 10-digit phone number";
    }

    if (!formData.message.trim()) {
      tempErrors.message = "Message is required";
    } else if (formData.message.length < 10) {
      tempErrors.message = "Message must be at least 10 characters";
    }

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      console.log("Form submitted:", formData);
     
    }
  };

  return (
    <div className="contactus-container">
      <section className="contactus-hero">
        <div
          className="contactus-hero-image"
          style={{
            backgroundImage: `url("https://res.cloudinary.com/dy8shu8ss/image/upload/v1738314701/pexels-olly-789822_z4d14f.jpg")`,
          }}
        ></div>
        <div className="contactus-hero-overlay">
          <h1>Contact Us</h1>
          <p>We're here to help! Reach out to us for any inquiries or feedback.</p>
        </div>
      </section>

      <section className="contactus-main">
        <div className="contactus-info">
          <div className="contactus-info-item">
            <FaEnvelope className="contactus-icon" />
            <h2>Email</h2>
            <p>venkatmor@verodisruptors.com</p>
            <p>contact@verodisruptors.com</p>
          </div>
          <div className="contactus-info-item">
            <FaMapMarkerAlt className="contactus-icon" />
            <h2>Office Address</h2>
            <p>
              
              H.No: 3-77, Thimmanapalem(V)<br />
              Korisapadu (MD), Bapatla (DT)<br />
              Andhra Pradesh - 523212<br />
              India
            </p>
          </div>
          <div className="contactus-info-item">
            <FaPhone className="contactus-icon" />
            <h2>Phone</h2>
            <p>+91 9032584791</p>
          </div>
        </div>

        
      </section>

      <section className="contactus-map">
        <h2>Find Us on Google Maps</h2>
        <iframe
          title="Vero Disruptors Office Location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3841.2564551593346!2d80.02021867472133!3d15.684534184940613!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a4af971b2d7f37f%3A0xd3e4ad8e991eb0f7!2sVERO%20DISRUPTORS%20PVT%20LTD!5e0!3m2!1sen!2sin!4v1738317005692!5m2!1sen!2sin"
          width="100%"
          height="400"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
        ></iframe>
      </section>

      <footer className="footer">
        <div className="footer-content">
          <div className="footer-section">
            <h3>About Us</h3>
            <p>Vero Disruptors is a leading innovator in data-driven solutions, providing cutting-edge services to help businesses grow and succeed.</p>
          </div>
          <div className="footer-section">
            <h3>Quick Links</h3>
            <ul>
              <li><a href="/">Home</a></li>
              <li><a href="/products">Products</a></li>
              <li><a href="/services">Services</a></li>
              <li><a href="/careers">Careers</a></li>
              <li><a href="/contactus">Contact Us</a></li>
            </ul>
          </div>
          <div className="footer-section">
            <h3>Follow Us</h3>
            <div className="social-links">
              <a href="https://www.facebook.com/share/1AF81Af26p/" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <FaFacebook />
              </a>
              
              <a href="https://www.linkedin.com/company/vero-disruptors-pvt-ltd/?originalSubdomain=in" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <FaLinkedin />
              </a>
              
            </div>
            
          </div>
          
        </div>
        <div className="footer-legal-links">
        
        <a href="/contactus">Contact Us</a>
        <a href="/terms">Term Of Use</a>
        <a href="/privacy">Privacy Statement</a>
        <a href="/refund">            Refund Policy
      </a>
        <a href="/about">About Us</a>
      
      </div>
      
        <div className="contactus-footer">
          <p>Copyright © Vero Disruptors {new Date().getFullYear()}. All rights reserved.</p>
        </div>
      </footer>
      
    </div>
  );
};

export default ContactUs;